<template>
  <v-row class="pb-5">
    <v-col cols="12" sm="6" md="9" class="d-flex align-center pr-sm-5">
      <BaseFilter
        v-model="filter"
        :textPlaceholder="'Buscar'"
        v-bind="defaultConfigs"
        @search="searchByFilter"
      />
    </v-col>
    <v-spacer />
    <v-col cols="12" sm="6" md="3" v-if="canSeeNewModality">
      <BaseButton
        class="white--text secondary"
        width="100%"
        @click="showModalCreate"
      >
        <v-icon class="pr-2">
          fa-plus
        </v-icon>
        INCLUIR MODALIDADE
      </BaseButton>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from "vuex";
const defaultProps = {
  outlined: true,
  dense: true,
  "background-color": "white",
  class: "filter__icon",
  "append-outer-icon": "fa-search"
};
export default {
  data: () => ({
    filter: null
  }),
  computed: {
    ...mapState(["userPermissions"]),
    canSeeNewModality() {
      return this.userPermissions.acoes.some(x => x.id == "criar_modalidade");
    },
    defaultConfigs() {
      return {
        ...defaultProps
      };
    }
  },
  methods: {
    showModalCreate() {
      this.$emit("modal");
    },
    searchByFilter() {
      this.$emit("filter", this.filter);
    }
  }
};
</script>
<style lang="sass">
.header-modality__title
    font-size: 18px
    font-weight: 800
    @media(min-width: 960px) and (max-width: 1264px)
      font-size: 16px
</style>
